/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskGradeInput } from './taskGradeInput';
import type { GradePreviewRequestModuleSubmissionId } from './gradePreviewRequestModuleSubmissionId';

/**
 * Request body for POST /grade-preview.
 */
export interface GradePreviewRequest {
  taskInputs: TaskGradeInput[];
  moduleSubmissionId?: GradePreviewRequestModuleSubmissionId;
}
